import { Header } from '@retainerclub/customer-shared';
import { Outlet } from 'react-router';
import { AccountConsentGate } from '../../views/AccountConsent';
import { SubscriptionAcknowledgmentGate } from '../../views/SubscriptionDisclosure';
import Footer from './Footer/Footer';

function MainLayout() {
  return (
    <div className="relative flex min-h-full flex-col bg-white">
      <Header className="fixed z-20 w-full" />

      <main className="relative mt-[68px] pb-[80px]">
        <Outlet />
      </main>
      <AccountConsentGate />
      <SubscriptionAcknowledgmentGate />
      <Footer />
    </div>
  );
}

export default MainLayout;
